import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const MetaOverviewGate = React.lazy(() => import("./MetaOverview.gate"));

const MetaOverviewLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <MetaOverviewGate />
  </React.Suspense>
);

export default () => <MetaOverviewLoadable />;
